import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>This Page is not found...</h1>
    </div>
  );
};

export default NotFound;
